// Registers dayjs plugins globally once at startup.
//
// Before route-level code splitting, every screen module (and antd's DatePicker, which
// registers these same plugins) was loaded eagerly at startup, so these plugins were
// always active - e.g. dayjs(value, 'DD-MM-YYYY') relies on customParseFormat, which was
// registered by PendingRequests.js. With screens now loaded on demand, register them here
// so dayjs behaves the same no matter which screen loads first.
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
